import React from 'react';
import { FileTextIcon, UsersIcon, BellIcon, TrendingUpIcon } from 'lucide-react';
export const Services = () => {
  const services = [{
    icon: <FileTextIcon size={24} className="text-indigo-600" />,
    title: 'Copy Optimization',
    description: 'Craft compelling emails and sales letters that convert. Optimize your messaging to resonate with your audience and drive results.',
    items: ['Email sequences', 'Sales letters', 'Website copy', 'Ad copy']
  }, {
    icon: <UsersIcon size={24} className="text-indigo-600" />,
    title: 'Lead Generation',
    description: 'Identify and attract high-quality leads that are actually interested in your product or service, not just padding your numbers.',
    items: ['Lead magnets', 'Qualification systems', 'Prospect research', 'Outreach campaigns']
  }, {
    icon: <BellIcon size={24} className="text-indigo-600" />,
    title: 'Paid Advertising',
    description: 'Create and manage paid campaigns that deliver ROI. Focus on efficient ad spend and continuous optimization.',
    items: ['PPC management', 'Social media ads', 'Retargeting', 'Analytics & reporting']
  }, {
    icon: <TrendingUpIcon size={24} className="text-indigo-600" />,
    title: 'Organic Growth',
    description: 'Build a sustainable social media presence that attracts your ideal customers through valuable content and strategic engagement.',
    items: ['Content strategy', 'Audience building', 'Engagement tactics', 'Platform optimization']
  }];
  return <section id="services" className="w-full py-20 px-6 md:px-12 bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
            How I Help You Grow
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Tailored marketing solutions that focus on real results.
            Each service is designed to directly impact your bottom line.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {services.map((service, index) => <div key={index} className="bg-gray-50 rounded-lg p-8 hover:shadow-md transition-shadow">
              <div className="flex items-center mb-4">
                {service.icon}
                <h3 className="text-xl font-semibold text-gray-800 ml-3">
                  {service.title}
                </h3>
              </div>
              <p className="text-gray-600">{service.description}</p>
              <ul className="mt-4 grid grid-cols-2 gap-2">
                {service.items.map((item, idx) => <li key={idx} className="flex items-center text-gray-700">
                    <div className="w-1.5 h-1.5 bg-indigo-600 rounded-full mr-2"></div>
                    {item}
                  </li>)}
              </ul>
            </div>)}
        </div>
      </div>
    </section>;
};